// ConfirmCancelModal.jsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';

const ConfirmCancelModal = ({ isOpen, onClose, onConfirm, workspace, task }) => {
    const workspaceName = workspace?.workspaceName || 'the workspace';
    const taskName = task?.taskName || 'the current task';

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
                    <motion.div
                        initial={{ opacity: 0, y: -20, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 20, scale: 0.95 }}
                        className="relative w-full max-w-md bg-surface rounded-xl border border-border-color shadow-xl"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex items-start gap-4 p-4">
                            <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-surface-dark">
                                <AlertTriangle size={20} className="text-warning" />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-lg font-bold text-on-surface">Cancel and Revert Task?</h3>
                                <p className="text-sm text-on-surface-dim mt-2">
                                    You are about to cancel <strong className="text-on-surface">{taskName}</strong> in the <strong className="text-on-surface">{workspaceName}</strong> workspace.
                                </p>
                                <p className="text-sm text-on-surface-dim mt-2">
                                    This will stop the task immediately and revert any file changes made during this phase. This action cannot be undone.
                                </p>
                            </div>
                             <button onClick={onClose} className="absolute top-3 right-3 p-1 rounded-full text-on-surface-dim hover:bg-surface-dark transition-colors">
                                <X size={18} />
                            </button>
                        </div>

                        <div className="flex justify-end gap-3 mt-2 p-4 bg-background-dark border-t border-border-color">
                            <button onClick={onClose} className="px-4 py-2 text-sm font-semibold rounded-md bg-surface-dark hover:bg-surface-raised text-on-surface transition-colors">
                                Nevermind
                            </button>
                            <button
                                onClick={() => {
                                    if (workspace && task) {
                                        onConfirm(workspace.id, task.phaseId || task.id);
                                    }
                                }}
                                className="px-4 py-2 text-sm font-semibold rounded-md bg-warning text-white hover:brightness-110 transition-colors"
                            >
                                Yes, Cancel and Revert
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default ConfirmCancelModal;